(() => {
  if (customElements.get('pd2-newsletter')) return;
  customElements.define('pd2-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.form || !this.input || !this.button || !this.status) return;
      this.company = this.dataset.company.trim();
      this.list = this.dataset.list.trim();
      this.ready = /^[A-Za-z0-9]+$/.test(this.company) && /^[A-Za-z0-9]+$/.test(this.list);
      this.label = this.button.textContent;
      this.button.disabled = !this.ready || Boolean(this.complete);
      this.controller = new AbortController();
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.ready && !this.busy && !this.complete && this.form.reportValidity()) this.submit();
      }, { signal: this.controller.signal });
    }

    async submit() {
      this.busy = true;
      this.button.disabled = true;
      this.input.readOnly = true;
      this.button.textContent = this.dataset.busy;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 15000);
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.input.value.trim(),
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: this.list } } }
        }
      };
      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.company)}`, {
          method: 'POST',
          headers: { revision: '2025-01-15', 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
          signal: request.signal,
          credentials: 'omit'
        });
        if (response.status !== 200 && response.status !== 202) throw new Error('Subscription request failed');
        if (!this.isConnected || this.request !== request) return;
        this.complete = true;
        this.status.textContent = this.dataset.success;
      } catch (_) {
        if (!this.isConnected || this.request !== request) return;
        this.status.textContent = this.dataset.error;
        this.status.setAttribute('data-error', '');
      } finally {
        clearTimeout(timeout);
        if (this.request === request) this.busy = false;
        if (this.isConnected && this.request === request) {
          this.button.disabled = !this.ready || Boolean(this.complete);
          this.input.readOnly = Boolean(this.complete);
          this.button.textContent = this.label;
          this.form.removeAttribute('aria-busy');
        }
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.request?.abort();
      this.request = null;
      this.busy = false;
    }
  });
})();
